import React from 'react'

import { QuantityBadge } from '@components/common/QuantityBadge'
import { Dropdown, Icon, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon, PlaceholderPhotoIcon } from '@fourthwall/icons'

import * as S from './styled'

export type Props = {
  title: string
  quantity: number
  thumbnailUrl?: string
  options?: {
    label: string
    onClick: () => void
  }[]
}

export const SeriesCell = ({ title, quantity, thumbnailUrl, options }: Props) => (
  <S.Container>
    <S.ThumbnailContainer>
      {quantity > 0 ? <QuantityBadge quantity={quantity} /> : null}
      {thumbnailUrl ? (
        <S.Thumbnail src={thumbnailUrl} />
      ) : (
        <Icon component={PlaceholderPhotoIcon} height={32} />
      )}
    </S.ThumbnailContainer>
    {title}
    {options && options.length > 0 && (
      <S.Options>
        <Dropdown
          content={options.map(({ label, onClick }) => (
            <Dropdown.Item
              key={label}
              label={label}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()

                onClick()
              }}
            />
          ))}
          position="bottom-end"
        >
          <ToolbarButton icon={DotsHorizontalIcon} />
        </Dropdown>
      </S.Options>
    )}
  </S.Container>
)
